<template>
  <div v-if="show()">
    <SwitchButton
      :show-button="showButton"
      :name="actionInfo.Desc"
      :show-label="showLabel"
      :is-i-f-t-t="isIFTT"
      :is-check="actionInfo.ischeck"
      :css-name="getCssName()"
      :show-check-box="showCheckBox"
      :check-box-value="actionInfo.ischeck"
      :hide-check-box="hideCheckBox()"
      @click="clickFn"
      @changeCheckBox="changeCheckBox"
    >
      <!--统一控制 子项-->
      <ChooseItem
        :v-device-id="vDeviceId"
        :tip-type="tipType"
        :gp-details="gpDetails"
        :checkeddata="checkeddata"
        :is-i-f-t-t="isIFTT"
        :tem="actionInfo"
        :item="deviceInfo"
        :show-label="true"
        :is-need-auto-emit="isNeedAutoEmit"
        :control_space_progress="control_space_progress"
        :is-detail="isDetail"
        :device-model="deviceModel"
        :device-card-list="deviceCardList"
        :PlanId="PlanId"
        :is-edit-video-scene="isEditVideoScene"
        :only-scene-no-list="onlySceneNoList"
        :selected-scene-no="selectedSceneNo"
        :show-mode="showMode"
        @do-call-action="doCallAction"
      />
    </SwitchButton>
  </div>
</template>

<script>
import SwitchButton from '@/components/button/SwitchButton'
import ChooseItem from '@/components/button/ChooseItem'
import { ActionVo } from '@/utils/actionsHandler'

// Slider类型的控件 布局充满父组件  其余的组件弹性布局
const LEFTFILLVALUETYPE = [
  'UIControl_ColorTemperature',
  'UIControl_Bright',
  'UIControl_Slider',
  'UIControl_MotorTrace_Slider',
  'UIControl_MotorVerticalTrace_Slider',
  'UIControl_ColorTemperature_SDL_DUV',
  'UIControl_MotorAngle_Slider',
  'UIControl_SliderAndInput',
  'UIControl_ChooseRange',
  'UIControl_TianMu_PlaybackSpeed',
  'UIControl_TianMu_PlaybackSpeed_Group',
  'UIControl_ColorTemperature_SDL'

]

export default {
  name: 'ControlItem',
  components: {
    SwitchButton,
    ChooseItem
  },
  props: {
    isNeedAutoEmit: {
      type: Boolean,
      default: true,
    },
    control_space_progress: {
      type: Number,
      default: null,
    },
    tipType: {
      type: Number,
      default: -1,
    },
    gpDetails: {
      type: Array,
      default() { return [] }
    },
    //是否显示使能禁能按钮
    showButton: {
      type: Boolean,
      default: true
    },
    checkeddata: {
      type: Array,
      default() { return [] }
    },
    //设备信息
    deviceInfo: {
      type: Object,
      default() { return {} }
    },
    //能力信息
    actionInfo: {
      type: Object,
      default() { return {} }
    },
    //是否自动化,不显示使能禁能
    isIFTT: {
      type: Boolean,
      default: false
    },
    //是否是详情页面
    isDetail: {
      type: Boolean,
      default: false
    },
    //是否显示checkbox
    showCheckBox: {
      type: Boolean,
      default: false
    },
    vDeviceId: {
      type: String,
      default: null
    },
    //天幕视频
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    //天幕视频ID
    PlanId: {
      type: String,
      default: '',
    },
    deviceModel: {
      type: Object,
      default: () => ({}),
    },
    isEditVideoScene:{
      type: Boolean,
      default: false
    },
    onlySceneNoList:{
      type: Boolean,
      default: false
    },
    selectedSceneNo:{
      type: Number,
      default: 0,
    },
    showMode: {
      type: Number,
      default: 0,
    },
    actionList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      isFoldTitle: false,
    }
  },
  computed: {
    //判断是否显示value名字 有多个value才显示
    showLabel() {
      let num = 0;
     
      if (this.actionInfo && this.actionInfo.Values) {
        this.actionInfo.Values.forEach(item => {
          if (item.IsShow) {
            num += 1
          }
        })
      }
      
      return num > 1 || num ==0
    }
  },
  watch: {
    vDeviceId(v) {
      console.log('this.vDeviceId', v);
    }
  },
  methods: {
    clickFn(value) {
      if (value === true) {
        const checkedActionList = this.actionList.filter(item => item.ischeck);

        const {
          result,
          passMsg
        } = ActionVo.isConflictAction('Scene', this.actionInfo.MsgType, checkedActionList);

        if (!result) {
          this.$message.warning(passMsg)
          return
        }
      }
      

      // debugger
      this.actionInfo.ischeck = value
      this.$emit('button-action', this.actionInfo)
    },
    doCallAction(item, model, _type, isColor, value) {
      const valueType = item.Values.some(item=>item.ValueType === "UIControl_TianMu_Player")
      const fromWhere = item?.fromWhere
      if(valueType && fromWhere === 'lightLibrary'){
        //区分控制视频播放点击来源是设备操作还是光效库(videoPlayer)
        this.$emit('do-call-action-video', item, model, _type, isColor, value)
        return
      }
      this.$emit('do-call-action-middle', item, model, _type, isColor, value)
    },
    //valuetype里面有slide的组件,布局充满父组件
    getCssName() {
      if (this.actionInfo && this.actionInfo.Values && this.actionInfo.Values.length > 0) {
        const ValueTypes = this.actionInfo.Values.filter(item => item.IsShow).map((item) => item.ValueType) || []
        const find = ValueTypes.find(item => LEFTFILLVALUETYPE.includes(item))
        if (find) {
          return 'left-fill'
        }
      }
      return ''
    },
    //是否显示,,values存在valueType为''的情况'
    show() {
      // return true
      if (this.actionInfo && this.actionInfo.Values && this.actionInfo.Values.length > 0) {
        let result = this.actionInfo.Values.filter(item => item.IsShow).some(item => !!item.ValueType)
        return result
      }
      return false
    },
    changeCheckBox(val) {
      const checkedActionList = this.actionList.filter(item => item.ischeck);

      const {
        result,
        passMsg
      } = ActionVo.isConflictAction('IFTTT', this.actionInfo.MsgType, checkedActionList)

      if (val === false && !result) {
        this.$message.warning(passMsg)
        return
      }

      // return;
      console.log('.....changeCheckBox')
      this.$emit('changeCheckBox')
    },
    hideCheckBox() {
      if(!this.showCheckBox) return false
      console.log('.....hideCheckBox')  
      if(this.actionInfo.UI != null && this.actionInfo.UI.NoneNeedCallAction != undefined &&this.actionInfo.UI.NoneNeedCallAction == true){
        return true
      }else{
        return false
      }
    }
  }
}
</script>
